import MenuBottom from 'components/common/Menu/MenuBottom';
import Gift from 'components/Organisms/LoyaltyStore/Gift';
import ScoreLevel from 'components/Organisms/LoyaltyStore/ScoreLevel';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { getAuth, isNullOrEmpty, isPending, objToString, setRewardDetail } from '../../functions';
import {
  getListMyGiftGroupStoreAction,
  getProfileByC,
  getQuestAllAction,
  onDetailPointRank,
  onDisplayAllRewardList,
  onSearchChallengeDetail,
  resetStateAct,
} from '../../model/actions/LoyaltyAccountInfoAction';
import {
  imgbuttonGift,
  imgBVNTDiamond,
  imgBVNTGold,
  imgBVNTPlatinum,
  imgBVNTPremierHSBC,
  imgBVNTPremierHSBCsmall,
  imgBVNTs,
  imgBVNTSilverPlus,
} from '../../model/constants/variableConstant';
import { Main } from './styled';

class LoyaltyStore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      challenge: '',
      imgArr: imgBVNTs,
      imgArrGold: imgBVNTGold,
      imgArrDiamond: imgBVNTDiamond,
      imgArrPlatinum: imgBVNTPlatinum,
      imgArrButton: imgbuttonGift,
      imgArrSilver: imgBVNTSilverPlus,
      imgArrPremierHSBC: [''],
      err: null,
      modalGiftDetail: false,
    };
    this.challenge = null;
  }

  updateSrcImg = () => {
    if (window.innerWidth <= 1024) {
      this.setState({
        imgArrPremierHSBC: imgBVNTPremierHSBCsmall,
      });
    } else {
      this.setState({
        imgArrPremierHSBC: imgBVNTPremierHSBC,
      });
    }
  };

  onResize = () => {
    if (this.rqf) return;
    if (typeof window !== 'undefined')
      this.rqf = window.requestAnimationFrame(() => {
        this.rqf = null;
        this.updateSrcImg();
      });
  };
  componentDidMount() {
    this.updateSrcImg();
    if (typeof window !== 'undefined') window.addEventListener('resize', this.onResize, false);
  }

  componentWillMount() {
    const auth = getAuth();
    const eposGiftInfofr = {
      memberCode: auth?.username,
      // giftGroupCodeFilter: 'GiftGroup_20200827091558709_7513', /*UAT*/
      // giftGroupCodeFilter: 'GiftGroup_20200714024738494_5028', /*PROD*/
      skipCount: 0,
      maxResultCount: 6,
    };

    this.props.getListMyGiftGroupStoreAction(eposGiftInfofr);
    //this.props.getByGiftGroup();
    this.props.getProfileByC(auth?.username);
    //this.props.getGiftDetailByGroupAction();

    window.removeEventListener('resize', this.onResize);
  }

  onSearchChallengeDetail = (values) => {
    const { onSearchChallengeDetail } = this.props;
    onSearchChallengeDetail(objToString(values.challenge));
  };

  onDisplayAllRewardList = () => {
    /*const {onDisplayAllRewardList} = this.props
		onDisplayAllRewardList()*/
  };

  onDetailPointRank = (values) => {
    setRewardDetail(values);
    window.location.href = '/pages/point-rank';
  };

  render() {
    const { loyaltyAccountInfoReducer } = this.props;
    /*Quà tặng*/
    let listMyGift = loyaltyAccountInfoReducer.listGroupGift;
    let twoImage = [];
    if (listMyGift?.obj?.length > 2) {
      twoImage.push(listMyGift.obj[0]);
      twoImage.push(listMyGift.obj[1]);
    } else {
      twoImage = listMyGift;
    }

    const profilebyc = loyaltyAccountInfoReducer.profilebyc;
    const processBar = isPending(loyaltyAccountInfoReducer.pending);

    return (
      <Main className='pb-72px'>
        {processBar}
        <ScoreLevel loyaltyData={profilebyc} />
        <Gift loyaltyData={profilebyc} />
        <br />
        {this.props.isMobile && <MenuBottom />}
      </Main>
    );
  }

  componentWillUnmount() {
    this.props.resetStateAct();
  }
}

const mapStateToProps = (state) => {
  return {
    loyaltyAccountInfoReducer: state.LoyaltyAccountInfoReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSearchChallengeDetail: (challenge) => dispatch(onSearchChallengeDetail(challenge)),
    //onDisplayToRedeem: (introduce) => dispatch(onDisplayToRedeem(introduce)),
    onDisplayAllRewardList: () => dispatch(onDisplayAllRewardList()),
    getListMyGiftGroupStoreAction: (challenge) =>
      dispatch(getListMyGiftGroupStoreAction(challenge)),
    getProfileByC: (challenge) => dispatch(getProfileByC(challenge)),
    getQuestAllAction: (resQuest) => dispatch(getQuestAllAction(resQuest)),
    onDetailPointRank: () => dispatch(onDetailPointRank()),
    resetStateAct: () => dispatch(resetStateAct()),
  };
};

LoyaltyStore = reduxForm({
  form: 'LoyaltyStore',
})(LoyaltyStore);

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyStore);
